import { type FilterProperty } from '@/types/advanceFilter';

import { defaultOperatorFor } from './OperatorSelect';

/**
 * A condition for `property` with no values yet — the shape a freshly added
 * filter chip or condition row starts from. The operator is the first one the
 * property's relation allows, matching what OperatorSelect preselects.
 */
export const createEmptyCondition = (
  property: FilterProperty,
  value?: string
) => ({
  property: property.name,
  operator: defaultOperatorFor(property),
  value: value ? [value] : [],
});
